/**
 * Pill-style category filter. Markup matches `.filter-bar` + `.filter-btn`.
 *
 *   options:  [{ id, label, count? }]
 *   value:    selected id (or 'all')
 *   onChange: (id) => void
 */
export function FilterBar({ options = [], value = 'all', onChange, includeAll = true, allLabel = 'All' }) {
  const choices = includeAll ? [{ id: 'all', label: allLabel }, ...options] : options;
  return (
    <div className="filter-bar" role="tablist">
      {choices.map((opt) => (
        <button
          key={opt.id}
          type="button"
          role="tab"
          aria-selected={value === opt.id}
          className={`filter-btn${value === opt.id ? ' active' : ''}`}
          onClick={() => onChange?.(opt.id)}
        >
          {opt.label}
          {opt.count != null && (
            <span style={{ opacity: 0.5, marginLeft: 6, fontSize: 12 }}>({opt.count})</span>
          )}
        </button>
      ))}
    </div>
  );
}
